import { render, staticRenderFns } from "./DodFiltersCheckboxes.vue?vue&type=template&id=27f85116&scoped=true&"
import script from "./DodFiltersCheckboxes.vue?vue&type=script&lang=js&"
export * from "./DodFiltersCheckboxes.vue?vue&type=script&lang=js&"
import style0 from "./DodFiltersCheckboxes.vue?vue&type=style&index=0&id=27f85116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f85116",
  null
  
)

export default component.exports